// extracted by css-extract-rspack-plugin
export default {"shortText":"PlaygroundTokenUsageWidget-module__shortText__EX8_q","longText":"PlaygroundTokenUsageWidget-module__longText__feeY8"};